import React, { FunctionComponent } from 'react';
import { TypographyName } from '@doveit/bricks';
import SeoLinksList from '../../../components/seo-links-list/SeoLinksList';
import PageSection from '../../../components/page-section/PageSection';
import { URLObject } from '../../../utils/links';
import { SeoLink } from '../../../components/seo-links/SeoLinks';

export interface LinksListSectionProps extends React.AriaAttributes {
  title: string,
  description?: string,
  links: SeoLink[],
  onLinkClick: (to: URLObject) => void,
}

export const LinksListSection: FunctionComponent<LinksListSectionProps> = ({
  title,
  description,
  links,
  onLinkClick,
  ...rest
}) => (
  <PageSection {...rest}>
    <PageSection.Title size={TypographyName.H3}>
      {title}
    </PageSection.Title>
    {description && (
      <PageSection.Description text={description} />
    )}
    <PageSection.Block>
      <SeoLinksList
        links={links}
        onLinkClick={onLinkClick}
      />
    </PageSection.Block>
  </PageSection>
);

export default LinksListSection;
